export const buildProjectNumber = (base, length) => {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  const randomValues = new Uint32Array(length);
  // eslint-disable-next-line no-undef
  window.crypto.getRandomValues(randomValues);

  let result = base;
  randomValues.forEach((value) => {
    result += characters.charAt(value % charactersLength);
  });
  return result;
};
